import { supabase } from '../lib/supabase';
class PortfolioService {
    async fetchPortfolios() {
        try {
            const { data, error } = await supabase
                .from('portfolios')
                .select('*')
                .order('created_at', { ascending: false });
            if (error) {
                console.error('Error fetching portfolios:', error);
                return [];
            }
            return data || [];
        }
        catch (error) {
            console.error('Error fetching portfolios:', error);
            return [];
        }
    }
    async createPortfolio(portfolio) {
        try {
            const { data: { user } } = await supabase.auth.getUser();
            const { data, error } = await supabase
                .from('portfolios')
                .insert([{
                    ...portfolio,
                    created_by: user?.id
                }])
                .select()
                .single();
            if (error) {
                console.error('Error creating portfolio:', error);
                return null;
            }
            return data;
        }
        catch (error) {
            console.error('Error creating portfolio:', error);
            return null;
        }
    }
    async updatePortfolio(id, updates) {
        try {
            const { data, error } = await supabase
                .from('portfolios')
                .update({
                ...updates,
                updated_at: new Date().toISOString()
            })
                .eq('id', id)
                .select()
                .single();
            if (error) {
                console.error('Error updating portfolio:', error);
                return null;
            }
            return data;
        }
        catch (error) {
            console.error('Error updating portfolio:', error);
            return null;
        }
    }
    async deletePortfolio(id) {
        try {
            const { error } = await supabase
                .from('portfolios')
                .delete()
                .eq('id', id);
            if (error) {
                console.error('Error deleting portfolio:', error);
                return false;
            }
            return true;
        }
        catch (error) {
            console.error('Error deleting portfolio:', error);
            return false;
        }
    }
}
export const portfolioService = new PortfolioService();
